import { AnimatePresence, MotiView } from "moti";
import React, { ReactNode } from "react";
import { View } from "react-native";

import {
  AnimationDurations,
  AnimationEasings,
} from "../../../../theme/animations";
import { OpenPosition } from "../types";
import { getAnimationFromOpenPosition } from "../utils";

/**
 * for larger screens, handles wrapping our content in a "bubble" right
 * near the trigger
 */

type ModalContentContainerProps = {
  modalBodyRef: any;
  measureScreenPosition: () => void;
  isOpen: boolean;
  isClosing: boolean;
  openPosition: OpenPosition;
  children: ReactNode;
};

export const ModalContentContainer = ({
  modalBodyRef,
  measureScreenPosition,
  isOpen,
  isClosing,
  openPosition,
  children,
}: ModalContentContainerProps) => {
  return (
    <View ref={modalBodyRef as any} onLayout={measureScreenPosition}>
      <AnimatePresence>
        {isOpen && !isClosing ? (
          <MotiView
            testID="modal-menu-content-container"
            {...getAnimationFromOpenPosition(openPosition)}
            transition={{
              opacity: {
                type: "timing",
                duration: AnimationDurations.moderate01,
                easing: isClosing
                  ? AnimationEasings.exit
                  : AnimationEasings.entrance,
              },
              left: {
                type: "timing",
                duration: AnimationDurations.moderate01,
                easing: isClosing
                  ? AnimationEasings.exit
                  : AnimationEasings.entrance,
              },
              top: {
                type: "timing",
                duration: AnimationDurations.moderate01,
                easing: isClosing
                  ? AnimationEasings.exit
                  : AnimationEasings.entrance,
              },
              right: {
                type: "timing",
                duration: AnimationDurations.moderate01,
                easing: isClosing
                  ? AnimationEasings.exit
                  : AnimationEasings.entrance,
              },
              bottom: {
                type: "timing",
                duration: AnimationDurations.moderate01,
                easing: isClosing
                  ? AnimationEasings.exit
                  : AnimationEasings.entrance,
              },
            }}
            style={{
              position: "relative",
            }}
          >
            {children}
          </MotiView>
        ) : null}
      </AnimatePresence>
    </View>
  );
};
